/**
 * @owner @Appboy/core-objects
 */

// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf, anyOf, recordOf, maybe } from "@altostra/type-validations";
import { string, boolean, number, nullValidation, any } from "@altostra/type-validations/lib/primitives";

export const isAppSettingsGetCustomEventPropertiesResult = objectOf({
  event_properties: arrayOf(
    objectOf({
      name: string,
      data_type: anyOf(string, nullValidation),
      blacklisted: boolean,
      detected_data_type: string,
      campaigns_using_me: anyOf(recordOf({ value: objectOf({ name: string }) })),
      workflows_using_me: anyOf(recordOf({ value: objectOf({ name: string, step_names: arrayOf(string) }) })),
      event_properties_namespace: string,
      schema: maybe(arrayOf(any)),
    })
  ),
  hits: number,
});
